export const USER_ROLES = {
    Doctor: 'doctor',
    Patient: 'patient',
    Admin: 'admin'
}
